/**
 * Verzendbelofte: vult alle [data-shipping-promise]-elementen met de tekst die
 * past bij het huidige moment in Nederland (Europe/Amsterdam).
 *
 * - Voor 17:00 op een verzenddag:                 "Voor 17:00 besteld, vandaag verzonden"
 * - Na 17:00, volgende dag is ook een verzenddag: "Nu besteld, morgen verzonden"
 * - Anders (vr na 17:00, weekend, feestdag):      "Nu besteld, {dag} verzonden"
 *
 * Teksten, daginamen en dagen zonder verzending komen uit
 * snippets/shipping-promise-config.liquid (#shipping-promise-config). De server
 * rendert alleen de fallback-tekst; als dit script of de berekening faalt blijft
 * die gewoon staan.
 *
 * Test-override (alleen op niet-gepubliceerde thema's): ?sp_now=2026-10-23T17:05
 * wordt gelezen als Nederlandse tijd.
 *
 * Dit bestand regelt ook de klik-handlers van de verzend-tooltip
 * (snippets/shipping-notice.liquid), via event delegation.
 */
(function () {
  'use strict';

  var TIME_ZONE = 'Europe/Amsterdam';
  var CUTOFF_HOUR = 17;
  var REFRESH_MS = 60 * 1000;
  var DAY_MS = 24 * 60 * 60 * 1000;
  var WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var DAY_PLACEHOLDER = '__DAY__';

  /* ---------- Berekening (puur, geen DOM) ---------- */

  // 'now' als { y, m, d, hour } in Nederlandse tijd, via Intl (niet de tijd van de bezoeker).
  function getAmsterdamNow(date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return {
      y: parseInt(values.year, 10),
      m: parseInt(values.month, 10),
      d: parseInt(values.day, 10),
      hour: parseInt(values.hour, 10) % 24
    };
  }

  // ?sp_now=2026-10-23T17:05 (of 2026-10-23 17:05) als Nederlandse wandtijd.
  function parseOverride(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{1,2})(?::(\d{2}))?)?$/.exec(value || '');
    if (!match) return null;
    return {
      y: parseInt(match[1], 10),
      m: parseInt(match[2], 10),
      d: parseInt(match[3], 10),
      hour: match[4] ? parseInt(match[4], 10) : 0
    };
  }

  // Kalenderdagen rekenen we als UTC-middernacht, zodat zomer-/wintertijd er niet toe doet.
  function dayKey(ms) {
    return new Date(ms).toISOString().slice(0, 10);
  }

  function parseBlackout(raw) {
    var set = {};
    String(raw || '').split(/\r?\n/).forEach(function (line) {
      var value = line.trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) set[value] = true;
    });
    return set;
  }

  function isShippingDay(ms, blackout) {
    var weekday = new Date(ms).getUTCDay();
    return weekday >= 1 && weekday <= 5 && !blackout[dayKey(ms)];
  }

  // Geeft { type: 'today' | 'tomorrow' | 'weekday', weekday?: 1-5 }.
  function computePromise(now, blackout) {
    var today = Date.UTC(now.y, now.m - 1, now.d);
    var todayShips = isShippingDay(today, blackout);

    if (todayShips && now.hour < CUTOFF_HOUR) return { type: 'today' };
    if (todayShips && isShippingDay(today + DAY_MS, blackout)) return { type: 'tomorrow' };

    // Maximaal een jaar vooruit zoeken, zodat een foute instelling nooit een eindeloze lus geeft.
    for (var i = 1; i <= 366; i++) {
      var candidate = today + i * DAY_MS;
      if (isShippingDay(candidate, blackout)) {
        return { type: 'weekday', weekday: new Date(candidate).getUTCDay() };
      }
    }
    return null;
  }

  function buildText(promise, config) {
    if (!promise) return null;
    if (promise.type === 'today') return config.today;
    if (promise.type === 'tomorrow') return config.tomorrow;
    var dayName = config.days && config.days[promise.weekday];
    if (!dayName || !config.weekday) return null;
    return config.weekday.split(DAY_PLACEHOLDER).join(dayName);
  }

  // Exporteer voor tests in Node; in de browser doet dit niets.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      getAmsterdamNow: getAmsterdamNow,
      parseOverride: parseOverride,
      parseBlackout: parseBlackout,
      computePromise: computePromise,
      buildText: buildText
    };
  }

  if (typeof document === 'undefined' || window.__shippingPromiseInit) return;
  window.__shippingPromiseInit = true;

  /* ---------- DOM ---------- */

  var SELECTOR = '[data-shipping-promise]';
  var config = null;
  var blackout = null;

  function loadConfig() {
    if (config) return true;
    var element = document.getElementById('shipping-promise-config');
    if (!element) return false;
    config = JSON.parse(element.textContent);
    blackout = parseBlackout(config.blackout);
    return true;
  }

  function getNow() {
    if (config.testOverride) {
      var override = parseOverride(new URLSearchParams(window.location.search).get('sp_now'));
      if (override) return override;
    }
    return getAmsterdamNow(new Date());
  }

  function update() {
    try {
      var elements = document.querySelectorAll(SELECTOR);
      if (!elements.length || !loadConfig()) return;
      var text = buildText(computePromise(getNow(), blackout), config);
      if (!text) return;
      elements.forEach(function (element) {
        if (element.textContent !== text) element.textContent = text;
      });
    } catch (error) {
      // Bij een fout blijft de fallback-tekst uit de server staan.
    }
  }

  // Cart drawer, post-add drawer en section rendering vervangen HTML zonder
  // betrouwbaar event na de DOM-update, dus kijken we naar toegevoegde nodes.
  function containsPromise(node) {
    return node.nodeType === 1 && (node.matches(SELECTOR) || node.querySelector(SELECTOR) !== null);
  }

  function observe() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (containsPromise(added[j])) {
            update();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Tooltip (snippets/shipping-notice.liquid) ---------- */

  function closeTooltips(except) {
    document.querySelectorAll('.tooltip-icon.active').forEach(function (icon) {
      if (icon !== except) icon.classList.remove('active');
    });
  }

  document.addEventListener('click', function (event) {
    var icon = event.target.closest && event.target.closest('.tooltip-icon');
    if (icon) {
      // Capture-fase + stopPropagation: zelfde gedrag als de oude handler op het icoon zelf.
      event.stopPropagation();
      closeTooltips(icon);
      icon.classList.toggle('active');
    } else {
      closeTooltips();
    }
  }, true);

  /* ---------- Start ---------- */

  function init() {
    update();
    observe();
    window.setInterval(update, REFRESH_MS);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
